import React, { useState } from 'react';

const FooterSection = () => {
  const [activeItem, setActiveItem] = useState('');

  const faqData = {
    general: [
      {
        id: 'what-is-maia',
        question: 'What is MAIA?',
        answer: 'MAIA (Medical AI Assistant) is a clinical AI tool that delivers trusted, real-time guidance — tailored to your specialty and role. It combines natural language search, dose calculators, and case-based planning in one seamless interface.'
      },
      {
        id: 'who-is-maia-for',
        question: 'Who is MAIA for?',
        answer: "MAIA is designed for: <ul><li>Anesthesiologists and pain physicians</li><li>Perioperative nurses and allied health professionals</li><li>Medical educators and trainees</li><li>Clinicians seeking instant, context-aware support</li></ul> Additional specialties are being added based on user demand and clinical impact."
      },
      {
        id: 'who-created-maia',
        question: 'Who created MAIA?',
        answer: 'MAIA was co-created by Admir Hadzic, MD — founder of NYSORA and a globally recognized leader in regional anesthesia — alongside a founding team of practicing clinicians, product leaders, and AI engineers. The co-founders and advisors also include seasoned professionals from Amazon, J.P. Morgan, and TikTok, uniting deep expertise in healthcare, education, and frontier AI innovation.'
      }
    ],
    trust: [
      {
        id: 'why-trusted',
        question: 'Why is MAIA trusted by doctors globally?',
        answer: '<ul><li>Built on three decades of NYSORA’s peer-reviewed, evidence-based content</li><li>Created by practicing physicians and clinical educators</li><li>Designed for real-world workflows — not generic AI responses</li><li>Used and endorsed by global institutions and top hospitals</li></ul>'
      },
      {
        id: 'clinical-judgment',
        question: 'Is MAIA a replacement for clinical judgment?',
        answer: 'No. MAIA is an educational and decision-support tool. It is not a substitute for medical training, experience, or institutional protocols.'
      },
      {
        id: 'different-from-chatgpt',
        question: 'What makes MAIA different from tools like ChatGPT or OpenEvidence?',
        answer: 'MAIA is specialty- and role-aware. It doesn’t provide generic journal summaries — it delivers practical, tailored guidance based on clinically validated protocols. It’s built specifically for the healthcare environment, not retrofitted for it.'
      }
    ],
    access: [
      {
        id: 'how-to-access',
        question: 'How do I access MAIA?',
        answer: 'MAIA will launch in beta on the web, with mobile apps to follow shortly after. You can sign up for early access at ask-maia.com.'
      },
      {
        id: 'internet-required',
        question: 'Does MAIA require internet access?',
        answer: 'Yes, the current version of MAIA is cloud-based and requires internet access to retrieve and generate real-time responses.'
      },
      {
        id: 'global-availability',
        question: 'Is MAIA available globally?',
        answer: 'Yes, MAIA will be available to users worldwide, starting with English-language support. Multilingual support is planned in future releases.'
      }
    ]
  };

  const toggleItem = (itemId) => {
    setActiveItem(activeItem === itemId ? null : itemId);
  };

  return (
    <div id="faq" className="faq-section">
      <div className="faq-container">
        <div className="faq-header">
          <button className="faq-badge">FAQ</button>
          <h1 className="faq-title">Frequently Asked Questions</h1>
        </div>
        
        <div className="faq-content">
          {Object.entries(faqData).map(([section, items]) => (
            <div key={section} className="faq-section-group row">
              <div className="col-1"><h2 className="faq-section-title">{section.charAt(0).toUpperCase() + section.slice(1)}</h2></div>
              <div className="col-11 faq-items">
                {items.map((item) => (
                  <div key={item.id} className="faq-item">
                    <button
                      className={`faq-question ${activeItem === item.id ? 'active' : ''}`}
                      onClick={() => toggleItem(item.id)}
                    >
                      <span>{item.question}</span>
                      <svg 
                        className={`faq-chevron ${activeItem === item.id ? 'rotated' : ''}`}
                        width="20" 
                        height="20" 
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="6,9 12,15 18,9"></polyline>
                      </svg>
                    </button>
                    {activeItem === item.id && (
                      <div className="faq-answer" dangerouslySetInnerHTML={{ __html: item.answer }}>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        
        <div className="faq-disclaimer">
          MAIA is an educational tool and does not replace clinical judgment. All medical decisions should be confirmed using institutional protocols and current clinical guidelines.
        </div>
        
        <div className="faq-scroll-top">
          <button
            className="faq-scroll-top-btn me-3"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Go back to top"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="18,15 12,9 6,15"></polyline>
            </svg>
          </button>
          <div className="faq-scroll-top-label">Go back to top</div>
        </div>
      </div>
    </div>
  );
};

export default FooterSection; 